import { TextMessage } from '@helsenorge/framework-utils/types/entities';

export const DEFAULT_ERROR: TextMessage = {
  Title: 'Det har skjedd en teknisk feil.',
  Body: 'Prøv igjen senere.',
} as const;
